import qs from 'querystring';

/**
 * Retrieves personalized payment details based on the provided parameters.
 *
 * @async
 * @function getPersonalizedPaymentDetails
 * @param {Object} options - The options for fetching payment details.
 * @param {Function} options.fetchPayments - A function to fetch payment details.
 * @param {string} options.paymentCalculationUrl - The base URL for payment calculation.
 * @param {Object} options.personalizedPaymentParams - Parameters for personalized payment calculation.
 * @param {string|number} [options.personalizedPaymentParams.terms] - The terms for payment calculation.
 * @param {string|number} [options.personalizedPaymentParams.leaseTerms] - The lease terms for payment calculation.
 * @returns {Promise<Object>} A promise that resolves to an object containing either the payment details or an error.
 * @throws {Error} If an error occurs during the fetch operation.
 */

const getPersonalizedPaymentDetails = async _ref => {
  let {
    fetchPayments,
    paymentCalculationUrl,
    personalizedPaymentParams
  } = _ref;
  const {
    terms,
    leaseTerms
  } = personalizedPaymentParams;
  if (!!fetchPayments && paymentCalculationUrl && (terms || leaseTerms)) {
    try {
      const paymentDetails = await fetchPayments(paymentCalculationUrl + `&${qs.stringify(personalizedPaymentParams)}`);
      return {
        details: paymentDetails
      };
    } catch (error) {
      return {
        error
      };
    }
  }
  return {};
};
export { getPersonalizedPaymentDetails as default };
